import { Inject, Injectable } from '@angular/core';
import { GenericKeyStringObject } from '../../types/data.types';
import { WINDOW } from '../../tokens/window';
import { BrowserApiSupportService } from '../../services/browser-api-support/browser-api-support.service';
import { Counter } from './counter.type';

@Injectable({ providedIn: 'root' })
export class CountdownService {
  private counters: GenericKeyStringObject<Counter> = {};

  constructor(
    @Inject(WINDOW) private window: Window,
    private browserApi: BrowserApiSupportService
  ) {}

  public getCounter(key: string): Counter {
    if (!this.counters[key]) {
      this.counters[key] = new Counter(this.window, this.browserApi);
    }

    return this.counters[key];
  }
}
